// extracted by mini-css-extract-plugin
module.exports = {"links":"styles_links__9n_2E","link":"styles_link__hrdZZ","divider":"styles_divider__3udQN"};